import React from 'react'

import { useAllBrandAccounts } from '~/hooks/useAllBrandAccountsQuery'

import { useIsCoreMember } from '../useIsCoreMember'

import { useCommonQueryData } from './useCommonQueryData'

export const useCommonQueryBrandAccounts = () => {
  const isCoreMember = useIsCoreMember()
  const me = useCommonQueryData()
  const allBrandAccounts = useAllBrandAccounts()

  return React.useMemo(
    () => (isCoreMember ? allBrandAccounts : (me?.brandAccounts ?? [])),
    [allBrandAccounts, isCoreMember, me],
  )
}
